<template>
  <div class="login-container">
    <div class="login-content">
      <el-card class="login-box" shadow="always">
        <div class="login-header">
          <h2>资源分享</h2>
          <p class="subtitle">管理后台</p>
        </div>
        <el-form :model="loginForm" :rules="rules" ref="loginForm">
          <el-form-item prop="username">
            <el-input 
              v-model="loginForm.username" 
              placeholder="请输入用户名"
              prefix-icon="el-icon-user"
              size="large">
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input 
              v-model="loginForm.password" 
              type="password"
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
              size="large"
              @keyup.enter.native="handleLogin">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button 
              type="primary" 
              @click="handleLogin" 
              :loading="loading"
              size="large"
              style="width: 100%;">
              登录
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
    async handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true
            const res = await this.$axios.post('/auth/admin/login', this.loginForm)
            
            if (res.data.code === 200) {
              const data = res.data.data
              
              // user表专门存储后台管理员，不需要检查userType
              // 如果能从/auth/login接口返回且有token，就说明是后台管理员
              
              localStorage.setItem('admin_token', data.token)
              localStorage.setItem('admin_user', JSON.stringify(data))
              
              // 获取用户菜单，跳转到第一个有权限的页面
              try {
                const menuRes = await this.$axios.get('/admin/permission/menu')
                if (menuRes.data.code === 200 && menuRes.data.data) {
                  const menuData = menuRes.data.data
                  const modules = menuData.modules || []
                  const menus = menuData.menus || []
                  
                  // 保存菜单数据到localStorage
                  localStorage.setItem('admin_menu_data', JSON.stringify(menuData))
                  
                  // 检查是否有菜单权限
                  if (modules.length === 0 || menus.length === 0) {
                    this.$message.warning('您的账户还未分配角色或权限，请联系超级管理员')
                    // 跳转到首页（会显示提示信息）
                    this.$router.push('/').catch(err => {
                      if (err.name !== 'NavigationDuplicated') {
                        console.error(err)
                      }
                    })
                    return
                  }
                  
                  // 优先检查是否有首页权限（dashboard:view）
                  const dashboardMenu = menus.find(m => m.permissionKey === 'dashboard:view' && m.url === '/dashboard')
                  if (dashboardMenu) {
                    // 有首页权限，跳转到首页
                    this.$router.push('/dashboard').catch(err => {
                      if (err.name !== 'NavigationDuplicated') {
                        console.error('登录后跳转失败:', err)
                      }
                    })
                    return
                  }
                  
                  // 没有首页权限，找到第一个有url的菜单项
                  const firstMenu = menus.find(m => m.url)
                  const firstMenuUrl = firstMenu ? firstMenu.url : '/'
                  
                  // 跳转到第一个有权限的页面
                  this.$router.push(firstMenuUrl).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                      console.error('登录后跳转失败:', err)
                    }
                  })
                } else {
                  this.$message.warning('获取菜单权限失败，请重新登录')
                  // 跳转到首页
                  this.$router.push('/').catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                      console.error(err)
                    }
                  })
                }
              } catch (menuError) {
                console.error('获取菜单失败:', menuError)
                this.$message.error('获取菜单权限失败: ' + menuError.message)
                // 跳转到首页
                this.$router.push('/').catch(err => {
                  if (err.name !== 'NavigationDuplicated') {
                    console.error(err)
                  }
                })
              }
            } else {
              this.$message.error(res.data.message)
            }
          } catch (error) {
            this.$message.error('登录失败: ' + error.message)
          } finally {
            this.loading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-image: url('../../public/images/loginBg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

/* 添加半透明遮罩层 */
.login-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1;
}

.login-content {
  position: relative;
  z-index: 2;
}

.login-box {
  width: 420px;
  padding: 40px 35px;
  border-radius: 12px;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.95);
}

.login-header {
  text-align: center;
  margin-bottom: 35px;
}

.login-header h2 {
  font-size: 28px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 8px 0;
  letter-spacing: 2px;
}

.login-header .subtitle {
  font-size: 14px;
  color: #909399;
  margin: 0;
  letter-spacing: 1px;
}

/* 输入框样式优化 */
.login-box >>> .el-input__inner {
  border-radius: 6px;
  height: 45px;
  line-height: 45px;
}

.login-box >>> .el-input__prefix {
  line-height: 45px;
}

/* 登录按钮样式优化 */
.login-box >>> .el-button--large {
  height: 45px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 2px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .login-box {
    width: 90%;
    padding: 30px 25px;
  }
  
  .login-header h2 {
    font-size: 24px;
  }
}
</style>